export const departmentOptions = [
  { id: 1, name: "Account" },
  { id: 2, name: "Admin" },
  { id: 3, name: "HR" },
  { id: 4, name: "Management" },
  { id: 5, name: "Procurement" },
  { id: 6, name: "Marketing" },
  { id: 7, name: "Safety" },
  { id: 8, name: "Quality" },
  { id: 9, name: "operation " },
  { id: 10, name: "Inspection" },
];

export const branchOptions = [
  { id: 1, name: "Office" },
  { id: 2, name: "Site" },
];

export const designationOptions = [
  { id: 1, name: "Managing Director & Founder" },
  { id: 2, name: "Director & Founder" },
  { id: 3, name: "Office Assistant" },
  { id: 4, name: "Driver" },
  { id: 5, name: "Senior Supervisor" },
  { id: 6, name: "Manager- DGT" },
  { id: 7, name: "Senior Engineer" },
  { id: 8, name: "Inspector" },
  { id: 9, name: "Asst Account Manager" },
  { id: 10, name: "Senior Accountant" },
  { id: 11, name: "CEO" },
  { id: 12, name: "Head -HR" },
  { id: 13, name: "Supervisor" },
  { id: 14, name: "Accountant" },
  { id: 15, name: "Business Development Executive" },
  { id: 16, name: "Senior Manager - Procurment" },
  { id: 17, name: "Digital Marketing Executive" },
  { id: 18, name: "Junior Engineer" },
  { id: 19, name: "Mechanic" },
  { id: 20, name: "Assistant Mechanic" },
  { id: 21, name: "Receptionist" },
  { id: 23, name: "Chief Technology Officer" },
  { id: 24, name: "Data Entry Operator" },
  { id: 25, name: "Assistant Manager -Site Execution" },
  { id: 26, name: "Quality Manager" },
  { id: 27, name: "Safety Engineer" },
  { id: 28, name: "Report Assistant" },
  { id: 29, name: "Public Relation Officer" },
  { id: 30, name: "Head - Digital Marketing" },
  { id: 31, name: "Dy.Quality Manager" },
  { id: 32, name: "Product Manager" },
  { id: 33, name: "Marketing Executive" },
  { id: 34, name: "HR Executive" },
  { id: 35, name: "Deputy Manager" },
  { id: 36, name: "Surveyor" },
  { id: 37, name: "operation manager" },
  { id: 38, name: "Project Co-ordinator" },
];

export const nablDesignationOptions = [
  { id: 1, name: "Technical Manager" },
  { id: 2, name: "Dy. Technical Manager" },
  { id: 3, name: "Test Engineer" },
  { id: 4, name: "Senior Test Engineer" },
  { id: 5, name: "Junior Test Engineer" },
  { id: 6, name: "Report Engineer" },
  { id: 7, name: "Senior Report Engineer" },
  { id: 8, name: "Junior Report Engineer" },
  { id: 9, name: "Geologist" },
  { id: 10, name: "Senior Geologist" },
  { id: 11, name: "Junior Geologist" },
  { id: 12, name: "Lab Assistant" },
  { id: 13, name: "Lab Helper" },
  { id: 14, name: "Lab Technician" },
  { id: 15, name: "Report Assistant" },
];

export const HR_employeeStatus = [
  { id: 1, name: "Active" },
  { id: 2, name: "Terminated " },
  { id: 3, name: "Resigned" },
];

export const employeeTypeOptions = [
  { id: 1, name: "Payroll Employee" },
  { id: 2, name: "Contract Employee" },
  { id: 3, name: "Trainee Employee" },
  { id: 4, name: "Empanel Employee" },
];
